// extracted by css-extract-rspack-plugin
export default {"description":"CustomFields__description--W__kp"};